import React, { useState } from 'react';
import { ChartIcon, ReaderIcon } from '@/assets/ui/toggle';

interface Props {
  onClick: (...args: any[]) => void;
  displayIcons?: boolean;
  initialState?: boolean;
}

const ToggleButton = ({ onClick, displayIcons = true, initialState = false }: Props) => {
  const [isChecked, setIsChecked] = useState(initialState);

  const toggleSwitch = () => {
    onClick();
    setIsChecked(!isChecked);
  };

  return (
    <div className='flex items-center space-x-2'>
      {displayIcons && (
        <ChartIcon
          className={`w-4 h-4 fill-current ${!isChecked ? 'text-primary' : 'text-gray-400'}`}
        />
      )}
      <button
        className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${isChecked ? 'bg-primary' : 'bg-gray-300 dark:bg-[#4a4d50]'}`}
        onClick={toggleSwitch}
      >
        <span
          className={`inline-block w-4 h-4 transform transition-transform bg-white rounded-full ${
            isChecked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      {displayIcons && (
        <ReaderIcon className={`w-6 h-6 ${isChecked ? 'text-primary' : 'text-gray-400'}`} />
      )}
    </div>
  );
};

export default ToggleButton;
